import React from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import { Pager } from "../../../components/Pager";
import Loader from "../../../components/Loader";
import Row from "./Row";
import Empthy from "../../../components/Empty";
import { useUser } from "../../../context";
import redeem from "../../../i11/Redeem";

const Table = ({
	open,
	data,
	getList,
	isLoading,
	page,
	setPage,
	total,
	exp = false,
}) => {
	const { locale } = useUser();
	return (
		<div className={cn(styles.wrapper)}>
			<div className={cn(styles.table)}>
				<div className={styles.row}>
					<div className={styles.col} />
					<div className={styles.col} />
					<div className={styles.col}>{redeem[locale].user}</div>
					<div className={styles.col}>{redeem[locale].date}</div>
					<div className={styles.col}>{redeem[locale].status}</div>
					<div className={styles.col} />
				</div>
				{data.map((e) => {
					if (exp)
						return (
							<Row
								fullData={e}
								exp
								getList={getList}
								open={open}
								key={e._id}
								data={{
									_id: e._id,
									updatedAt: e.updatedAt,
									image: e.nftId?.image || "",
									name: e.nftId?.name || "",
									owner: {
										userName: e.nftOwner?.email,
									},
									redeemStatus: e.status,
								}}
							/>
						);
					return (
						<Row
							getList={getList}
							open={open}
							key={e._id}
							data={e}
						/>
					);
				})}
			</div>
			{data.length === 0 && !isLoading && <Empthy />}
			{isLoading && <Loader className={styles.loader} />}
			<div className={styles.foot}>
				<Pager page={page} setPage={setPage} total={total} />
			</div>
		</div>
	);
};

export default Table;
